export const Flag = ({ color }: { color: string }) => (
	<svg fill="none" className="flag" viewBox="0 0 111 29">
		<path
			d="M0 0.877441H111V20.1334L55.5 28.9591L0 20.1334V0.877441Z"
			fill={color}
		/>
	</svg>
);
